if (!customElements.get("popup-toggle")) {
  class PopupToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent("exo:popup-toggle", {
          detail: { id: this.getAttribute("data-id") },
        })
      );
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("popup-toggle", PopupToggle);
}
